import { createContext } from 'react';
import { i as initialUIDPrefixer } from './initialUIDPrefixer-d586e58f.js';

const UIDContext = /*#__PURE__*/createContext(initialUIDPrefixer);
var UIDContext$1 = UIDContext;

export { UIDContext$1 as U };
//# sourceMappingURL=UIDContext-6eff6071.js.map
